import c from '@/styles/MostRead';
import { ClassNameProp, ComponentPropsWithRef, ComponentWithRef } from '@/types/component';
import { cn } from '@/utils/cn';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';
import { withNonHTMLChildren } from '@/utils/withNonHTMLChildren';
import { withSafeInnerHTML } from '@/utils/withSafeInnerHTML';
import React from 'react';

export interface MostReadSlideGroupProps extends ComponentPropsWithRef<'ul'> {
  variant?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'default'>;
}

export const MostReadSlideGroupComponent: ComponentWithRef<HTMLUListElement, MostReadSlideGroupProps> =
  React.forwardRef(({ children, className, colors, size, variant, ...props }, ref) => {
    const getPropStyles = getPropStylesFactory(c);

    const colorsClassName = getPropStyles('slide_group_colors', colors, 'default');
    const variantClassName = getPropStyles('slide_group_variant', variant, 'default');
    const sizeClassName = getPropStyles('slide_group_size', size, 'default');

    const componentClassName = cn(variantClassName, className, colorsClassName, sizeClassName);

    return (
      <ul className={componentClassName} {...withSafeInnerHTML(children)} {...props} {...{ ref }}>
        {withNonHTMLChildren(children)}
      </ul>
    );
  });
